// Redux slice quản lý khách hàng
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

// Async thunk: cập nhật khách hàng
export const updateKhachHang = createAsyncThunk("khachHang/updateKhachHang", async ({ id, data }, { rejectWithValue }) => {
  try {
    // Loại bỏ các key không cần gửi lên server khi cập nhật
    const { appointment_ids: _appointment_ids, consultation_ids: _consultation_ids, payment_ids: _payment_ids, ...rest } = data || {};
    const payload = {
      ...rest,
      is_patient: true,
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    };
    const res = await api.put(`/res.partner/${id}`, payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// Async thunk: lấy danh sách khách hàng
// Nhận params động (page, size) từ component
export const fetchKhachHangList = createAsyncThunk("khachHang/fetchList", async (params = {}, { rejectWithValue }) => {
  try {
    const queryParams = {
      ...params,
      size: params.size || 10,
      page: params.page || 1,
      is_patient: true,
      search: params.search || "",
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    };
    // thêm queryParams customer_group_id nếu có
    if (params.customer_group_id) {
      queryParams.customer_group_id = params.customer_group_id;
    }
    if (params.active) {
      queryParams.active = params.active;
    }

    const res = await api.get("/res.partner", {
      params: queryParams,
    });
    // Trả về cả content và totalElements để phân trang
    return {
      content: res.data.content || [],
      group_summary: res.data.group_summary || [],
      totalElements: res.data.totalElements || 0,
    };
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// Async thunk: thêm mới khách hàng
export const addKhachHang = createAsyncThunk("khachHang/addKhachHang", async (data, { rejectWithValue }) => {
  console.log("Adding new customer with data:", data);
  try {
    const res = await api.post("/res.partner", {
      ...data,
      is_patient: true,
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    });
    return res.data;
  } catch (err) {
    console.log("err ", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

// Async thunk: xóa khách hàng
export const deleteKhachHang = createAsyncThunk("khachHang/deleteKhachHang", async ({ id }, { rejectWithValue }) => {
  try {
    await api.delete(`/res.partner/${id}`, {
      operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
    });
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// Async thunk: lấy chi tiết khách hàng
export const fetchKhachHangDetail = createAsyncThunk("khachHang/fetchDetail", async (id, { rejectWithValue }) => {
  try {
    const res = await api.get(`/res.partner/${id}`, {
      params: {
        operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
      },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const initialState = {
  list: {
    content: [],
    totalElements: 0,
  },
  detail: null,
  loading: false,
  loadingDetail: false,
  error: null,
};

const khachHangSlice = createSlice({
  name: "khachHang",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchKhachHangList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKhachHangList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchKhachHangList.rejected, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addKhachHang.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addKhachHang.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addKhachHang.rejected, (state) => {
        state.loading = false;
        state.error = null;
      })
      // Update khách hàng
      .addCase(updateKhachHang.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateKhachHang.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateKhachHang.rejected, (state) => {
        state.loading = false;
        state.error = null;
      })
      // Delete khách hàng
      .addCase(deleteKhachHang.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteKhachHang.fulfilled, (state, action) => {
        console.log("Deleted customer:", action.payload);
        state.loading = false;
        state.list.content = state.list.content.filter((d) => d.id !== action.payload);
      })
      .addCase(deleteKhachHang.rejected, (state) => {
        state.loading = false;
        state.error = null;
      })
      // Fetch khách hàng detail
      .addCase(fetchKhachHangDetail.pending, (state) => {
        state.loadingDetail = true;
        state.error = null;
      })
      .addCase(fetchKhachHangDetail.fulfilled, (state, action) => {
        state.loadingDetail = false;
        state.detail = action.payload;
      })
      .addCase(fetchKhachHangDetail.rejected, (state, action) => {
        state.loadingDetail = false;
        state.error = action.payload;
      });
  },
});

// Export actions và reducer
export default khachHangSlice.reducer;
